import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "✓";
  const outcome2 = "✓";
  // const outcome3 = "✓";
  const outcome4 = "✓";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            {/* <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Inhouse R&D</h5>
                    <p className="mb-0">V2G Optimization using Predictive Analytics</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Modern grid systems must efficiently schedule energy flows between EVs and grids, balancing demand, price, and vehicle availability.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">We implemented a hybrid CNN + LSTM architecture that predicts load, price, and charging schedules using vehicle, weather, and grid data. Early-stage validation is underway with partners like SWTCH Energy.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>Accurate scheduling with time-series forecasting</li>
                  <li>Smart charging optimization</li>
                  <li>Foundational model for bidirectional V2G integration</li>
                </ul>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Bi-directional Load Forecasting</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Charging Schedule Prediction</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Time-Series AI for Grid Balancing</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div> */}
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Chmltech Ltd.</h5>
                    <p className="mb-0">Hydrogen Microgrid Optimization for Chmltech Ltd.</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Chmltech needed an AI-based solution to analyze and optimize the performance of their green hydrogen-based microgrid.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">We developed advanced Machine Learning models to assess hydrogen system metrics and identify inefficiencies. A real-time dashboard was deployed to visualize performance indicators, forecast production trends, and inform energy decisions.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>Integrated solar and environmental data</li>
                  <li>Real-time fuel cell and electrolyser performance projections</li>
                  <li>Predictive modeling for system tuning and downtime prevention</li>
                </ul>
                {/* <h6 className="mb-4">Impact</h6>
                <p className="mb-0">The solution enhanced energy yield while reducing dependency on centralized cloud systems, demonstrating the viability of AI-powered optimization in extreme maritime conditions.</p> */}
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Visual Dashboards for Monitoring</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Energy Optimization Models</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  {/* <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Time-Series AI for Grid Balancing</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div> */}
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>AI Forecasting For Electrolyzers</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;